import { Badge } from "@/design-system/Badge";
import { Button } from "@/design-system/Button";
import { Inline } from "@/design-system/Inline";
import { useTranslation } from "@/translations";

import type { IconComponent } from "../Icon/Icon";

export type PillListItem = {
  prefix?: string;
  label: string;
  icon?: IconComponent;
};

type PillListProps = {
  label?: string;
  items: PillListItem[];
  maxShown?: number;
  onClickOmittedItems?: () => void;
};

export function PillList({ label, items, maxShown, onClickOmittedItems }: PillListProps): React.ReactNode {
  const { t } = useTranslation();

  const visibleItems = maxShown ? items.slice(0, maxShown) : items;

  return (
    <Inline gap="sm" align="center" wrap={false}>
      {label && <span className="text-body">{label}:</span>}
      <Inline gap="xs" align="center">
        {visibleItems.map((item, index) => (
          <Badge key={`${item.label}-${index}`} variant="white" prefix={item.prefix} icon={item.icon}>
            {item.label}
          </Badge>
        ))}
        {maxShown &&
          items.length > maxShown &&
          (onClickOmittedItems ? (
            <Button variant="ghostPrimary" size="sm" onClick={onClickOmittedItems}>
              {t("common.label.x-more", { count: items.length - maxShown })}
            </Button>
          ) : (
            <span className="text-caption-emphasis text-text-secondary">
              {t("common.label.x-more", { count: items.length - maxShown })}
            </span>
          ))}
      </Inline>
    </Inline>
  );
}
